import { SharedState } from '@trello/shared-state';

interface CardComposerSharedState {
  /**
   * When this is not null, we can infer that the card composer is open.
   */
  activeListId: string | null;
  /**
   * The active position for the card composer. Cards are rendered with position
   * in the list, and the card composer is meant to be opened in a single place
   * matching a target position.
   */
  activePosition: number | null;
  /**
   * inputValue stores the user input across rerenders.
   */
  inputValue: string;
}

export const defaultCardComposerState: CardComposerSharedState = {
  activeListId: null,
  activePosition: null,
  inputValue: '',
};

export const cardComposerSharedState = new SharedState<CardComposerSharedState>(
  defaultCardComposerState,
);
